/* ============================================================
   KRUNCHIE NATURALS — Cart Drawer JS
   Uses Shopify AJAX Cart API (/cart.js, /cart/change.js)
   ============================================================ */

(function () {
  'use strict';

  const drawer   = document.getElementById('cart-drawer');
  const overlay  = document.getElementById('cart-overlay');
  const closeBtn = document.getElementById('cart-drawer-close');
  const openBtns = document.querySelectorAll('[data-cart-open]');
  const badge    = document.getElementById('cart-badge');

  if (!drawer) return;

  /* ── OPEN / CLOSE ── */
  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchAndRender();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  openBtns.forEach(btn => btn.addEventListener('click', openDrawer));
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
  window.closeDrawerGlobal = closeDrawer;

  /* ── FETCH & RENDER ── */
  function fetchAndRender() {
    drawer.classList.add('is-loading');
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        renderCart(cart);
        updateBadge(cart.item_count);
      })
      .catch(err => console.error('[Cart] fetch error:', err))
      .finally(() => drawer.classList.remove('is-loading'));
  }

  /* ── BADGE ── */
  function updateBadge(count) {
    if (!badge) return;
    badge.textContent = count;
    badge.dataset.count = count;
    badge.classList.remove('bump');
    void badge.offsetWidth;
    badge.classList.add('bump');
    setTimeout(() => badge.classList.remove('bump'), 300);
  }

  /* ── FORMAT MONEY ── */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2) + ' CAD';
  }

  /* ── RENDER ── */
  function renderCart(cart) {
    const body    = document.getElementById('cart-drawer-body');
    const footer  = document.getElementById('cart-drawer-footer');
    const counter = document.getElementById('cart-drawer-count');

    if (counter) {
      counter.textContent = cart.item_count;
      counter.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    }

    if (cart.item_count === 0) {
      body.innerHTML = emptyHTML();
      footer.style.display = 'none';
    } else {
      body.innerHTML = itemsHTML(cart);
      footer.innerHTML = footerHTML(cart);
      footer.style.display = '';
      bindItemEvents();
      bindDiscountToggle();
      bindDiscountApply(cart);
    }
  }

  /* ── EMPTY STATE ── */
  function emptyHTML() {
    const loginUrl = window.Shopify
      ? '/account/login'
      : '/account/login';

    return `
      <div class="cart-empty">
        <h3>Your cart is empty</h3>
        <p class="cart-empty__login">
          Have an account?
          <a href="${loginUrl}">Log in</a>
          to check out faster.
        </p>
        <a href="/collections/all" class="btn-cart-empty" onclick="window.closeDrawerGlobal()">
          Continue Shopping
        </a>
      </div>
    `;
  }

  /* ── ITEMS HTML ── */
  function itemsHTML(cart) {
    const rows = cart.items.map(item => {
      const img = item.image
        ? `<img class="cart-item__image" src="${item.image}" alt="${item.title}" loading="lazy" />`
        : `<div class="cart-item__image--placeholder">
             <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
               <rect x="3" y="3" width="18" height="18" rx="2"/>
               <circle cx="8.5" cy="8.5" r="1.5"/>
               <polyline points="21 15 16 10 5 21"/>
             </svg>
           </div>`;

      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<span class="cart-item__variant">${item.variant_title}</span>` : '';

      return `
        <div class="cart-item" data-key="${item.key}">
          ${img}
          <div class="cart-item__details">
            <div class="cart-item__top">
              <span class="cart-item__name">${item.product_title}</span>
              <span class="cart-item__price-top">${money(item.final_line_price)}</span>
            </div>
            ${variant}
            <span class="cart-item__unit-price">${money(item.final_price)}</span>
            <div class="cart-item__actions">
              <div class="qty-stepper" data-key="${item.key}">
                <button class="qty-stepper__btn" data-action="decrease" aria-label="Decrease">−</button>
                <span class="qty-stepper__val">${item.quantity}</span>
                <button class="qty-stepper__btn" data-action="increase" aria-label="Increase">+</button>
              </div>
              <button class="cart-item__remove" data-key="${item.key}" aria-label="Remove ${item.product_title}">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="3 6 5 6 21 6"/>
                  <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                  <path d="M10 11v6M14 11v6"/>
                  <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      `;
    }).join('');

    return `<div class="cart-items">${rows}</div>`;
  }

  /* ── FOOTER HTML ── */
  function footerHTML(cart) {
    // NOTE: Shopify does not support applying discount codes via AJAX API.
    // The code is appended to the checkout URL as ?discount=CODE — the
    // standard Shopify workaround used by all major themes.

    return `
      <!-- Collapsible discount -->
      <div>
        <button class="cart-discount__toggle" id="cart-discount-toggle" aria-expanded="false" aria-controls="cart-discount-body">
          Discount
          <span class="cart-discount__toggle-icon" aria-hidden="true">+</span>
        </button>
        <div class="cart-discount__body" id="cart-discount-body" role="region">
          <input
            type="text"
            class="cart-discount__input"
            id="cart-discount-input"
            placeholder="Discount code"
            aria-label="Discount code"
            autocomplete="off"
            autocapitalize="characters"
          />
          <button class="cart-discount__apply" id="cart-discount-apply">Apply</button>
        </div>
        <p class="cart-discount__msg" id="cart-discount-msg" aria-live="polite"></p>
      </div>

      <!-- Estimated total -->
      <div>
        <div class="cart-totals__row">
          <span>Estimated total</span>
          <span id="cart-total">${money(cart.total_price)}</span>
        </div>
        <p class="cart-totals__note">Taxes and shipping calculated at checkout.</p>
      </div>

      <!-- Checkout CTA -->
      <a href="/checkout" id="cart-checkout-btn" class="cart-checkout-btn">
        Check out
      </a>

      <!-- Dynamic payment buttons
           ─────────────────────────────────────────────────────────
           Shopify injects Shop Pay, PayPal, Google Pay etc. here
           via content_for_additional_checkout_buttons in the Liquid
           template (snippets/cart-drawer.liquid). This JS footer
           HTML is used only when JS re-renders after AJAX updates;
           the Liquid version handles first paint. The payment buttons
           themselves are managed entirely by each payment app —
           no configuration needed here.
           ───────────────────────────────────────────────────────── -->
      <div class="cart-additional-btns" id="cart-additional-btns-js">
        <!-- Payment app buttons rendered by Liquid on first load;
             after AJAX updates this area is intentionally left empty
             so the apps re-initialise correctly on full page load. -->
      </div>
    `;
  }

  /* ── DISCOUNT TOGGLE ── */
  function bindDiscountToggle() {
    const toggle = document.getElementById('cart-discount-toggle');
    const body   = document.getElementById('cart-discount-body');
    if (!toggle || !body) return;

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      body.classList.toggle('is-open', !expanded);
    });
  }

  /* ── DISCOUNT APPLY ── */
  function bindDiscountApply(cart) {
    const applyBtn   = document.getElementById('cart-discount-apply');
    const msg        = document.getElementById('cart-discount-msg');
    const checkoutBtn = document.getElementById('cart-checkout-btn');
    if (!applyBtn) return;

    applyBtn.addEventListener('click', () => {
      const code = (document.getElementById('cart-discount-input').value || '').trim();
      if (!code) {
        msg.className = 'cart-discount__msg error';
        msg.textContent = 'Please enter a discount code.';
        return;
      }
      // Append to checkout URL — AJAX API limitation workaround
      if (checkoutBtn) {
        checkoutBtn.href = `/checkout?discount=${encodeURIComponent(code)}`;
      }
      msg.className = 'cart-discount__msg success';
      msg.textContent = `"${code}" will be applied at checkout.`;
    });
  }

  /* ── ITEM EVENTS (qty + remove) ── */
  function bindItemEvents() {
  document.querySelectorAll('.qty-stepper').forEach(stepper => {
    const key   = stepper.dataset.key;
    const valEl = stepper.querySelector('.qty-stepper__val');

    if (!key || !valEl) return;

    stepper.querySelectorAll('.qty-stepper__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const current = parseInt(valEl.textContent, 10);
        const newQty  = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
        changeItem(key, newQty);
      });
    });
  });

  document.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', () => changeItem(btn.dataset.key, 0));
  });
}

  /* ── CHANGE ITEM ── */
  function changeItem(key, quantity) {
    drawer.classList.add('is-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
      .then(r => r.json())
      .then(cart => {
        renderCart(cart);
        updateBadge(cart.item_count);
      })
      .catch(err => console.error('[Cart] change error:', err))
      .finally(() => drawer.classList.remove('is-loading'));
  }

  /* ── ADD-TO-CART HOOK ──
     Fire this event from any product form to open the drawer:
     document.dispatchEvent(new CustomEvent('cart:item-added'));
  ── */
  document.addEventListener('cart:item-added', openDrawer);

  /* ── INIT: badge count on page load ── */
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateBadge(cart.item_count))
    .catch(() => {});

})();
